import { createGaEventRecord } from "@/features/ga/utils";

export const gaEventRecords = {
  ...createGaEventRecord({
    billingMaacTopUpClick: {
      name: "billing_maac_top_up_click",
      description: "User clicks on the MAAC top-up button on the billing page",
    },
    billingCaacTopUpClick: {
      name: "billing_caac_top_up_click",
      description: "User clicks on the CAAC top-up button on the billing page",
    },
    gadsContactUsClick: {
      name: "gads_contact_us_click",
      description:
        "User clicks on the Contact Us button on Google Ads card when EC module is disabled",
    },
    productFeedContactUsClick: {
      name: "pf_contact_us_click",
      description:
        "User clicks on the Contact Us button on Product Feed card when module is disabled",
    },
    customFieldContactUsClick: {
      name: "cf_contact_us_click",
      description:
        "User clicks on the Contact Us button on Custom Field card when limit is not available",
    },
    openApiContactUsClick: {
      name: "openapi_contact_us_click",
      description:
        "User clicks on the Contact Us button on OpenAPI card when OpenAPI v2 is not enabled for the organization",
    },
    metaAdsContactUsClick: {
      name: "meta_ads_contact_us_click",
      description:
        "User clicks on the Contact Us button on the Meta Ads card when ad integration is not enabled",
    },
    lineAdsContactUsClick: {
      name: "line_ads_contact_us_click",
      description:
        "User clicks on the Contact Us button on the LINE Ads card when ad integration is not enabled",
    },
    ecommerceSetupClick: {
      name: "ecommerce_setup_click",
      description:
        "User clicks Set up in MAAC on an e-commerce platform card, opening the MAAC app market",
      labelDescription: "The platform type, e.g. shopify",
    },
    overviewAttentionClick: {
      name: "overview_attention_click",
      description: "User follows a Needs attention item on the Overview page",
      labelDescription:
        "The item kind: channels, metaAds, productFeeds, lowBalance or featureLimits",
    },
    overviewCompletenessClick: {
      name: "overview_completeness_click",
      description:
        "User clicks Connect on an item of the customer data checklist on the Overview page",
      labelDescription: "The item: line, social, web, ecommerce or unification",
    },
    dataFlowConnectClick: {
      name: "data_flow_connect_click",
      description:
        "User clicks Connect on a not-connected source in the data flow on the Unified contacts page",
      labelDescription: "The source: line, fb, ig, wccs or ecommerce",
    },
    dataFlowApiSourceClick: {
      name: "data_flow_api_source_click",
      description:
        "User clicks the POS and CRM (API) chip under Also connect in the data flow",
      labelDescription:
        "openapi when it opens the OpenAPI page, contact when it opens Contact us",
    },
    dataFlowDestinationClick: {
      name: "data_flow_destination_click",
      description:
        "User opens a place unified contacts are used, from the Used in column of the data flow",
      labelDescription: "The destination: maac, caac, daac, ads or api",
    },
    productSwitchClick: {
      name: "product_switch_click",
      description:
        "User opens another product from the side menu's product switcher",
      labelDescription: "The product: MAAC, CAAC or DAAC",
    },
    mcpContactUsClick: {
      name: "mcp_contact_us_click",
      description:
        "User clicks on the Contact Us button on MCP card when MCP is not enabled for the organization",
    },
  }),
};
